import { Dispatch } from 'react'

export enum ClientVisitedActionEnum {
    CLIENT_VISITED = 'client visited',
    CLIENT_CLEARED = 'client cleared'
}

export type ClientVisitedActionType = {
    type: ClientVisitedActionEnum
    clientCode?: string
}

export const setLastVisitedClientAction =
    (clientCode: string) => (dispatch: Dispatch<ClientVisitedActionType>) => {
        dispatch({
            type: ClientVisitedActionEnum.CLIENT_VISITED,
            clientCode
        })
    }

export const clearLastVisitedClientAction =
    () => (dispatch: Dispatch<ClientVisitedActionType>) => {
        dispatch({
            type: ClientVisitedActionEnum.CLIENT_CLEARED
        })
    }
